import { createSlice } from '@reduxjs/toolkit'
import { updateEstimatioQuotation } from 'redux/service/settingsService/estimaQuotaService';

const initialState = {
  updateEstimatioQuotationRes: { data: [], isFetching: false, error: null },
}

export const estimationQuotationSlice = createSlice({
  name: 'estimationQuotationSlice',
  initialState,
  extraReducers: (builder) => {
    // builder
    const asyncActionCases = [
      { api: updateEstimatioQuotation, name: "updateEstimatioQuotationRes" },
    ];
    asyncActionCases.map((asyncAction) => {
      builder
        .addCase(asyncAction.api.fulfilled, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].data = payload;
        })
        .addCase(asyncAction.api.pending, (state) => {
          state[asyncAction.name].isFetching = true;
          state[asyncAction.name].error = null;
        })
        .addCase(asyncAction.api.rejected, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].error = payload;
        });
    });
  },
})


export const { estimationQuotationDispatch } = estimationQuotationSlice.actions
